import { render, staticRenderFns } from "./UITh.vue?vue&type=template&id=5a3e8960"
import script from "./UITh.vue?vue&type=script&lang=js"
export * from "./UITh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports